export default __webpack_public_path__ + "static/media/icon_copy.66c8af0e.svg";